// extracted by mini-css-extract-plugin
export default {"button":"sfHYbJOjvCHp1gyIsScA","pulse":"DJVSyF6CyNlGrDjAxlWV"};